import React from "react";
import KaDialog from "../shared/KaDialog";
import Img from "../../assets/100.jpg";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
  imgBackground: {
    backgroundSize: "cover",
    backgroundPosition: "right center"
  },
  imgTag: {
    width: "100%",
    height: "auto",
    display: "block"
  },
  paragraph: {
    margin: theme.spacing(3, 0)
  }
}));

const KanzleiFlexibilitaet = ({ open, close }) => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl } = useScreensize();
  const theme = useTheme();

  const mobile = xs || sm;

  return (
    <>
      <KaDialog open={open} close={close}>
        <>
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            p={{ sm: 3, md: 3 }}
            height={mobile ? undefined : 700}
          >
            {mobile && (
              <Box
                bgcolor={theme.palette.primary.main}
                mb={3}
              >
                <img src={Img} alt="Flexibilität" className={classes.imgTag} />
              </Box>
            )}
            <Box
              color="white"
              p={{ xs: 3, sm: 4 }}
              mr={mobile ? 0 : 3}
              mb={mobile ? 3 : 0}
              flexGrow={1}
              bgcolor={theme.palette.primary.main}
              flexShrink={1}
              flexBasis={mobile ? "auto" : "0px"}
            >
              <Typography variant="h1" component="h2">
                Flexibilität
              </Typography>
              <Typography variant="h6" component="h3" gutterBottom>
                Wir halten Ihnen den Rücken frei
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Die steuerrechtlichen Arbeitsbereiche werden immer komplexer,
                die Märkte schneller und internationaler.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Mit modernen Informationstechnologien arbeiten wir
                teamorientiert und rationell und bieten Ihnen auch bei
                ausgefallenen Problemen „maßgeschneiderte“ Lösungen.
              </Typography>
              <Typography variant="body1" className={classes.paragraph}>
                Wir setzen alles daran, wirtschaftliche Zusammenhänge,
                betriebliche Notwendigkeiten und steuerliche Erfordernisse
                miteinander zu verknüpfen.
              </Typography>
            </Box>
            {!mobile && (
              <Box
                p={3}
                className={classes.imgBackground}
                style={{ backgroundImage: "url(" + Img + ")" }}
                flexGrow={1}
                bgcolor={theme.palette.primary.main}
                flexShrink={1}
                flexBasis="0px"
              ></Box>
            )}
          </Box>
        </>
      </KaDialog>
    </>
  );
};

export default KanzleiFlexibilitaet;
